import { useEffect } from 'react';

import { RouterProvider, RouterProviderProps } from '@router';
import { PostMessageType } from '@spazious/search-sdk-types';

import AppProvider, { AppProviderProps } from './AppProvider.js';
export type AppProps = Omit<AppProviderProps, 'children' | 'basename'> & {
  router: RouterProviderProps['router'];
};

/**
 * This component is the root of the application.
 */
export const App: React.FC<AppProps> = ({ router, ...restProps }) => {
  useEffect(() => {
    window.parent.postMessage({ type: PostMessageType.IFRAME_READY }, '*');
  }, []);
  return (
    <AppProvider {...restProps} basename={router.basename}>
      <RouterProvider router={router} />
    </AppProvider>
  );
};

export default App;
